// Audios urls.
const canceledOrderAudioUrl = process.env.REACT_APP_SOUND_CANCEL;
const offlineOrderAudioUrl = process.env.REACT_APP_SOUND_OFF_LINE;
const newOrderAudioUrl = process.env.REACT_APP_SOUND_NEW_ORDER;
const rtNotificationSoundUrl = process.env.REACT_APP_SOUND_RT_NOTIFICATION;
const orderMgmtNewOrderAudioUrl = process.env.REACT_APP_SOUND_NEW_ORDER_SHORT;

// Audio types.
const CANCELED_ORDER_AUDIO = 'CANCELED_ORDER_AUDIO';
const OFFLINE_AUDIO = 'OFFLINE_AUDIO';
const NEW_ORDER_AUDIO = 'NEW_ORDER_AUDIO';
const RT_NOTIFICATION_SOUND = 'RT_NOTIFICATION_SOUND';
const ORDER_MGMT_NEW_ORDER = 'ORDER_MGMT_NEW_ORDER';

/**
 * It is the audio instance.
 */
let audio;
/**
 *  Represents the audio currently being played.
 */
let audioBeingPlayed;

const getAudioBeingPlayed = () => {
  return audioBeingPlayed;
};

const playAudio = () => {
  try {
    audio.play();
  } catch (ex) {
    console.error(ex.message);
  }
};

const playOfflineAudio = () => {
  if (audio) {
    // If there is an audio being playing, pause it.
    audio.pause();
  }
  audioBeingPlayed = OFFLINE_AUDIO;
  audio = new Audio(offlineOrderAudioUrl);
  audio.loop = true;
  playAudio();
};

const playCanceledOrderAudio = () => {
  if (audio) {
    // If there is an audio being playing, pause it.
    audio.pause();
  }
  audioBeingPlayed = CANCELED_ORDER_AUDIO;
  audio = new Audio(canceledOrderAudioUrl);
  audio.loop = true;
  playAudio();
};

const playNewOrderAudio = () => {
  if (audio) {
    audio.pause();
  }
  audioBeingPlayed = NEW_ORDER_AUDIO;
  audio = new Audio(newOrderAudioUrl);
  audio.loop = true;
  playAudio();
};

const playNotificationRTSound = () => {
  if (audio) {
    audio.pause;
  }

  audioBeingPlayed = RT_NOTIFICATION_SOUND;
  audio = new Audio(rtNotificationSoundUrl);
  audio.loop = false;
  playAudio();
};

const pauseAudio = () => {
  if (!audio) {
    return;
  }
  audioBeingPlayed = null;
  audio.pause();
  audio = null;
};

const playOrderMgmtNewOrderSound = () => {
  if (audio) {
    audio.pause;
  }

  audioBeingPlayed = ORDER_MGMT_NEW_ORDER;
  audio = new Audio(orderMgmtNewOrderAudioUrl);
  audio.loop = false;
  playAudio();
};

export default {
  getAudioBeingPlayed,
  playCanceledOrderAudio,
  playNewOrderAudio,
  playNotificationRTSound,
  playOfflineAudio,
  pauseAudio,
  playOrderMgmtNewOrderSound,
};
